import { Flex, Text, FlexProps } from "@chakra-ui/react";

interface Props extends FlexProps {
  step: number;
  title: string;
  description: string;
}

const HomeStepCard = ({ step, title, description }: Props) => {
  return (
    <Flex
      flexDir="column"
      align="center"
      w="100%"
      maxW={["248px", null, null, null, null, "377px"]}
      borderRadius={["6.61386px", null, null, null, null, "10.0541px"]}
      boxShadow="0px 0px 12px rgba(0, 0, 0, 0.1)"
      background="#fff"
      pos="relative"
      pt={["30.79px", null, null, null, null, "46.81px"]}
      pb={["23.37px", null, null, null, null, "35.53px"]}
      px={["22px", null, null, null, null, "34px"]}
    >
      <Flex
        w={["49.46px", null, null, null, null, "75.18px"]}
        h={["49.46px", null, null, null, null, "75.18px"]}
        align="center"
        justify="center"
        borderRadius="50%"
        boxShadow="0px 0px 4px 0px #00000040"
        bgColor="white"
        pos="absolute"
        top="0"
        transform="translate(0, -50%)"
      >
        <Text
          as="span"
          fontSize={["0.875rem", null, null, null, null, "2.25rem"]}
          fontWeight="700"
          lineHeight={["1rem", null, null, null, null, "1.5rem"]}
        >
          {step}
        </Text>
      </Flex>
      <Text
        fontSize={["0.875rem", null, null, null, null, "1.445rem"]}
        fontWeight="700"
        lineHeight={["1.38875rem", null, null, null, null, "2.11125rem"]}
        letterSpacing={["0.83px", null, null, null, null, "1.27px"]}
        color="secondary"
        mb={["11.62px", null, null, null, null, "17.67px"]}
      >
        {title}
      </Text>
      <Text
        fontSize={["0.875rem", null, null, null, null, "1.375rem"]}
        fontWeight="400"
        lineHeight={["1.233125rem", null, null, null, null, "1.875rem"]}
        textAlign="center"
        maxW={["203px", null, null, null, null, "unset"]}
      >
        {description}
      </Text>
    </Flex>
  );
};

export default HomeStepCard;
